import { Base } from "./base";
import { getAccessToken } from "../utils/browserStorage";

export class WorkOrder extends Base {
  /**
   * @description List Location API function
   * @returns {Promise<Response>}
   */
  list(query) {
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL("/cmms/work-order?" + queryParam);
    return this._secureFetch(url);
  }

  getPublicToken() {
    const url = this._getFullURL("/cmms/request/update-new-url");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }

  setNewPublicToken(token) {
    const url = this._getFullURL(`/cmms/request/update-new-url`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        method: "PUT",
        payload: { url: token },
      })
    );
  }

  getOne(id) {
    const url = this._getFullURL("/cmms/work-order/" + id);
    return this._secureFetch(url);
  }
  getOneByToken(id) {
      const url = this._getFullURL(`/cmms/work-order-by-token/` + id);
      var requestOptions = {
          method: "GET",
          redirect: "follow",
      };
      return fetch(url, requestOptions);
  }

  delete(id) {
    const url = this._getFullURL("/cmms/work-order/" + id);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var requestOptions = {
      method: "DELETE",
      headers: myHeaders,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }

  create(payload, photoFiles) {
    const url = this._getFullURL("/cmms/work-order");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var formdata = new FormData();
    const metadata = [];
    const newAttachments = {};
    photoFiles.forEach((item, index) => {
      // You can give each file a custom field name like `files[]` or `file_0`
      if (!item.exist) {
        formdata.append("file_" + index, item.file); // backend must accept array uploads
        metadata.push({
          field: "file_" + index,
          name: item.name,
          type: item.type,
        });
      } else {
        newAttachments[item.origin_key] = item.value;
      }
    });
    if (metadata.length > 0)
      formdata.append("metadata", JSON.stringify(metadata));
    if (Object.keys(newAttachments).length > 0)
      formdata.append("attachments", JSON.stringify(newAttachments));
    Object.keys(payload).map((z) => {
      formdata.append(z, payload[z]);
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }
  createByToken(token, payload, photoFiles) {
    const url = this._getFullURL("/cmms/work-order-by-token?token=" + token);
    var myHeaders = new Headers();

    var formdata = new FormData();
    const metadata = [];

    const newAttachments = {};
    photoFiles.forEach((item, index) => {
      // You can give each file a custom field name like `files[]` or `file_0`
      if (!item.exist) {
        formdata.append("file_" + index, item.file); // backend must accept array uploads
        metadata.push({
          field: "file_" + index,
          name: item.name,
          type: item.type,
        });
      } else {
        newAttachments[item.origin_key] = item.value;
      }
    });
    if (metadata.length > 0)
      formdata.append("metadata", JSON.stringify(metadata));
    if (Object.keys(newAttachments).length > 0)
      formdata.append("attachments", JSON.stringify(newAttachments));
    Object.keys(payload).map((z) => {
      formdata.append(z, payload[z]);
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }

  update(id, payload, photoFile) {
    const url = this._getFullURL("/cmms/work-order/" + id);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var formdata = new FormData();
    const metadata = [];
    photoFile.forEach((item, index) => {
      // You can give each file a custom field name like `files[]` or `file_0`
      if (!item.exist) {
        formdata.append("file_" + index, item.file); // backend must accept array uploads
        metadata.push({
          field: "file_" + index,
          name: item.name,
          type: item.type,
        });
      }
    });
    if (metadata.length > 0)
      formdata.append("metadata", JSON.stringify(metadata));
    Object.keys(payload).map((z) => {
      formdata.append(z, payload[z]);
    });

    var requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }

  updateStatus(id, payload) {
    const url = this._getFullURL("/cmms/work-order/status/" + id);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var formdata = new FormData();

    Object.keys(payload).map((z) => {
      formdata.append(z, payload[z]);
    });

    var requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }

  updateRequestStatus(id, payload, photoFile) {
    const url = this._getFullURL("/cmms/work-order/request-status/" + id);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var formdata = new FormData();
    formdata.append("filePhoto", photoFile);

    Object.keys(payload).map((z) => {
      formdata.append(z, payload[z]);
    });

    var requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }

  addLogAttachment(id, payload, photoFile) {
    const url = this._getFullURL(
      `/cmms/work-order-logs/add-log-attachment/${id}`
    );
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);
    var formdata = new FormData();
    formdata.append("filePhoto", photoFile);
    Object.keys(payload).map((z) => {
      formdata.append(z, payload[z]);
    });

    var requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }

  addLogFeedbackAttachment(id, payload, photoFile) {
    const url = this._getFullURL(`/cmms/work-order-logs/${id}/comment`);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);
    var formdata = new FormData();
    formdata.append("filePhoto", photoFile);
    Object.keys(payload).map((z) => {
      formdata.append(z, payload[z]);
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }

  deleteFeedback(log_id, comment_id) {
    const url = this._getFullURL(
      `/cmms/work-order-logs/${log_id}/comment/${comment_id}`
    );
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        method: "DELETE",
      })
    );
  }

  /**
   * @description List Alert API function
   * @returns {Promise<Response>}
   */
  getLogs(id) {
    const url = this._getFullURL(`/cmms/work-order/${id}/logs`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        method: "GET",
      })
    );
  }

  import(payload, isRequest = false) {
    const url = this._getFullURL(`/cmms/work-order/import?isRequest=` + isRequest);

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }

  getOverlapingWorkOrder() {
    const url = this._getFullURL("/cmms/work-order/overlap");
    return this._secureFetch(url);
  }

  removeOverlapingWorkOrder(payload) {
    const url = this._getFullURL("/cmms/work-order/overlap/remove");
    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }

}
